import { Component, input, OnInit, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'file-load',
    templateUrl: './file-load.component.html',
    styleUrls: ['./file-load.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FileLoadComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatChipsModule, MatIconModule, MatButtonModule]
})
export class FileLoadComponent implements OnInit, ControlValueAccessor {
  fileTypes = input.required<string>();

  disabled = input<boolean>(false);

  public selectedFile!: any;
  public isFileLoader: boolean = false;

  value: any = '';

  onChange: any = (value: any) => {};
  onTouched: any = () => {};
  
  constructor() { }

  writeValue(value: any): void {
    this.selectedFile = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnInit(): void {
  }

  fileChangeEvent(event: Event) {
    
    if ((event.target as HTMLInputElement).files) {
      const target= event.target as HTMLInputElement;
      this.selectedFile = (target.files as FileList)[0];
      this.onChange(this.selectedFile);
    }
  }

  remove(file: any) {
    this.selectedFile = null;
    this.onChange(this.selectedFile);
  }
}
